<template>
    <div class="c-slideInOverlay" :class="{ 'is-open': isOpen }">
        <transition name="fade">
            <div
                class="c-slideInOverlay__background"
                @click="close"
                v-if="isOpen"
            ></div>
        </transition>

        <div class="c-slideInOverlay__inner">
            <div class="c-slideInOverlay__header">
                <div
                    class="c-slideInOverlay__close o-btn o-btn--return"
                    v-if="isOpen"
                    @click="close"
                >
                    {{ translations['Back'] }}
                </div>
                <div class="c-slideInOverlay__heading">
                    <slot name="heading"></slot>
                </div>
                <div class="c-slideInOverlay__tools">
                    <slot name="tools"></slot>
                </div>
            </div>
            <div class="c-slideInOverlay__wrapper customscroll">
                <div class="c-slideInOverlay__body">
                    <slot name="body"></slot>
                    <slot name="secondaryBody"></slot>
                </div>
            </div>
            <div class="c-slideInOverlay__footer" v-if="hasFooterSlot">
                <slot name="footer"></slot>
            </div>
            <div v-if="showLoader" class="c-slideInOverlay__loader">
                <inline-loader></inline-loader>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'

import InlineLoader from './InlineLoader.vue'

export default {
    name: 'SlideInOverlay',
    components: {
        InlineLoader,
    },
    props: {
        isOpen: {
            type: Boolean,
            default: true,
        },
        showLoader: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        ...mapState({
            translations: (state) => state.app.translations,
        }),
        hasFooterSlot() {
            return !!this.$slots.footer
        },
    },
    methods: {
        close() {
            this.$emit('close')
        },
    },
}
</script>

<style lang="scss">
@import '../../scss/abstracts/variables.scss';

.c-slideInOverlay {
    position: relative;

    &__loader {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        width: 100%;
        z-index: 20;
        background: #fff;
        display: flex;
        justify-content: center;
        align-items: center;

        .o-loaderInline {
            margin-left: -20px;
        }
    }

    &__background {
        background-color: $c-overlay;
        bottom: 0;
        left: 0;
        position: fixed;
        right: 0;
        top: 0;
        z-index: 15;
    }

    &__inner {
        display: flex;
        flex-direction: column;
        max-height: 100%;
        position: fixed;
        z-index: 20;
        top: 0;
        bottom: 0;
        right: 0;
        opacity: 0;
        width: calc(100% - 20px);
        max-width: 540px;
        background-color: $c-white;
        bottom: 0;
        border-radius: 2px 2px 0 0;
        box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);
        transform: translate(100%, 0);
        transition: transform 500ms $t-nice, opacity 300ms $t-nice;

        .is-open & {
            opacity: 1;
            transform: translate(0, 0);
        }
    }

    &__header {
        padding: 20px 30px;
        background: #fff;
        border-bottom: 1px solid #d9d4c8;
        text-align: center;
        min-height: 83px;

        display: flex;
        justify-content: center;
        align-items: center;
    }

    &__close {
        position: absolute;
        left: 30px;
        border: none;

        &:hover {
            cursor: pointer;
        }
    }

    &__heading {
        color: $c-black;
        font-family: $font-heading;
        font-size: 27px;
        letter-spacing: -0.21px;
        line-height: 42px;
        text-align: center;
        text-transform: uppercase;
    }

    &__tools {
        position: absolute;
        right: 30px;
    }

    &__wrapper {
        height: 100%;
        overflow-y: auto;
        overflow-x: hidden;
    }

    &__body {
        padding: 30px;
    }

    &__footer {
        padding: 36px 30px;
        border-top: 1px solid $c-light-grey;
    }

    &.is-open {
        .c-slideInOverlay__inner {
            opacity: 1;
            transform: translate(0, 0);
        }
    }

    &.has-footer {
        .c-slideInOverlay__body {
            bottom: 70px;
        }
    }
}
</style>
